var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":_vm.md,"cols":"12"}},[_c('v-switch',{attrs:{"label":_vm.$attrs.label},on:{"change":_vm.changeVal},model:{value:(_vm.enabled),callback:function ($$v) {_vm.enabled=$$v},expression:"enabled"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }